class BleedSlider extends HTMLElement {
  constructor() {
    super();
    this.emblaNode = this.querySelector('.embla');
    this.emblaContainer = this.querySelector('.embla__container');
    this.prevButtons = this.querySelectorAll('.prev');
    this.nextButtons = this.querySelectorAll('.next');
    this.options = {
      align: 'start',
      slidesToScroll: 1,
    };
  }

  connectedCallback() {
    if (!this.emblaNode || !this.emblaContainer) return;

    this.initSlider();
    this.setupNavigation();
  }

  initSlider() {
    this.embla = EmblaCarousel(this.emblaNode, this.options);
  }

  setupNavigation() {
    if (this.prevButtons.length && this.nextButtons.length) {
      this.prevButtons.forEach((button) => {
        button.addEventListener('click', () => {
          this.embla.scrollPrev();
          this.updateButtonStates();
        });
      });

      this.nextButtons.forEach((button) => {
        button.addEventListener('click', () => {
          this.embla.scrollNext();
          this.updateButtonStates();
        });
      });

      // Initial button states
      this.updateButtonStates();

      // Update button states on scroll
      this.embla.on('select', () => this.updateButtonStates());
    }
  }

  updateButtonStates() {
    const canScrollPrev = this.embla.canScrollPrev();
    const canScrollNext = this.embla.canScrollNext();

    this.prevButtons.forEach((button) => {
      button.disabled = !canScrollPrev;
      button.style.opacity = canScrollPrev ? '1' : '0.5';
    });

    this.nextButtons.forEach((button) => {
      button.disabled = !canScrollNext;
      button.style.opacity = canScrollNext ? '1' : '0.5';
    });
  }
}

customElements.define('bleed-slider', BleedSlider);
